import React, { Component } from 'react';
import { withStyles, WithStyles, createStyles } from '@mui/styles';
import { connect } from 'react-redux';
import { DateTime } from 'luxon';
import {
  Button,
  Checkbox,
  Accordion,
  AccordionSummary,
  FormControlLabel,
  AccordionDetails,
  FilledInput,
  Grid,
  Card,
  CardContent,
  Divider,
  Box,
  Paper,
  Typography,
  Alert,
  Snackbar,
  AlertTitle,
  SnackbarCloseReason,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
} from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  getFinancialDetails,
  confirmBooking,
  makePayment,
  getPaymentDetailsById,
  makeCoverPaymentCall,
  makePaymentCall,
  postCreatePaymentLink,
  getPaymentLinkDetails,
  getSetupIntentDetail,
  createPandaDoc,
  getPandaDocStatusById,
  sendPandaDoc,
} from 'actions/events';
import classNames from 'classnames';
import CompanyTerms from 'components/CompanyTerms';
import { ReduxState } from 'reducers/rootReducer';
import CompanyContext from 'company/CompanyContext';
import { formatMoney, formatMoneyRoundOff } from 'utilities/PriceFormatter';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from 'components/DialogTitle';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import LoaderOverlay from 'components/LoaderOverlay';
import moment from 'moment';

const styles = (theme: any) => createStyles({
  paper: {
    width: '800px',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    "@media (max-width: 425px)": {
      'flex-direction': 'column',
      'padding': '5',
    },
    "@media (max-width: 380px)": {
      'flex-direction': 'column',
      'padding': '5',
    },
  },
  extraPadding: {
    padding: '0px 24px',
    "@media (max-width: 420px)": {
      padding: 0,
    },
  },
  label: {
    color: theme.palette.blue.blue4,
    fontSize: 30,
    marginTop: '-5px',
    "@media (max-width: 420px)": {
      fontSize: 25,
      marginTop: 'auto',
    },
  },
  button: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.common.black,
    border: `1px solid ${theme.palette.blue.strongblue}`,
    verticalAlign: 'bottom',
    height: 48,
    width: 219,
    "@media (max-width: 420px)": {
      marginTop: 20,
      width: '100%',
      height: 'initial',
    },
  },
  buttonDisabled: {
    backgroundColor: 'rgba(0, 0, 0, 0.26)',
  },
  icon: {
    verticalAlign: 'middle',
    display: 'inline-block',
  },
  imgContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50%',
    "@media (max-width: 420px)": {
      width: '100%',
      paddingLeft: '24px',
    },
  },
  imageLogo: {
    maxWidth: '200px',
  },
  topRow: {
    display: 'flex',
    fontSize: 18,
    paddingTop: 15,
    flexDirection: 'column',
    "@media (max-width: 420px)": {
      'flex-direction': 'column',
    },
  },
  topHeader: {
    display: "flex",
    padding: "10px 24px",
    backgroundColor: theme.palette.blue.lightblue,
    flexDirection: "row",
    borderLeft: `1px solid ${theme.palette.blue.lightblue}`,
    borderTop: `1px solid ${theme.palette.blue.lightblue}`,
    borderRight: `1px solid ${theme.palette.blue.lightblue}`,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 400,
  },
  bookingDetails: {
    flexGrow: 1,
    justifyContent: "space-between",
    alignContent: "center",
    padding: '1em',
    fontSize: 14,
  },
  bottomHeader: {
    display: "flex",
    alignContent: "center",
    padding: "10px 24px",
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.background.border}`,
  },
  field: {
    fontSize: 14,
    paddingTop: 5,
  },
  subTitle: {
    fontSize: 13,
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
  financialsContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
    marginBottom: 36,
    "@media (max-width: 420px)": {
      fontSize: 12,
    },
  },
  financials: {
    flexGrow: 1,
    marginBottom: 8,
  },
  financialSummary: {
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
    justifyContent: 'center',
    backgroundColor: theme.palette.light.lightgrey,
    alignItems: 'center',
  },
  cardContainer: {
    display: 'flex',
    color: theme.palette.text.lightprimary,
    margin: 5,
    padding: 15,
    border: `1px solid ${theme.palette.background.border}`,
    borderBottomWidth: 7,
    borderBottomColor: theme.palette.blue.lightblue,
  },
  financials2: {
    width: 280,
    display: 'flex',
    fontSize: 14,
    flexDirection: 'column',
  },
  financialsHeader: {
    padding: 8,
    display: 'flex',
    justifyContent: 'center',
    fontSize: 18,
    backgroundColor: theme.palette.blue.lightblue,
    margin: '10px 16px',
  },
  finacialsField: {
    display: 'flex',
    marginBottom: 20,
    justifyContent: 'space-between',
  },
  finacialsField2: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 20,
  },
  payments: {
    flexGrow: 1,
    marginBottom: 5,
  },
  paymentsCardTitle: {
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 14,
    "@media (max-width: 420px)": {
      fontSize: 12,
    },
    width: "100%",
  },
  paymentsListContainer: {
    height: 500,
    maxHeight: 500,
    overflowY: 'scroll',
    paddingRight: 5,
    '&::-webkit-scrollbar': {
      width: '12px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.blue.lightblue,
      borderRadius: '3px',
      backgroundClip: 'padding-box',
      border: '5px solid rgba(0, 0, 0, 0)',
    },
  },
  paymentsContainer: {
    display: 'flex',
    color: theme.palette.text.primary,
    padding: '15px 35px 15px 25px',
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.background.border}`,
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  paymentsField: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    width: '27%',
  },
  paymentFooter: {
    backgroundColor: theme.palette.blue.lightblue,
    padding: 5,
    marginTop: 20,
  },
  bookingInfo: {
    color: theme.palette.text.secondary,
    "@media (max-width: 420px)": {
      textAlign: 'center',
      paddingBottom: '15px',
    },
  },
  topLeft: {
    paddingRight: 50,
    marginRight: 50,
    borderRight: `solid 1px ${theme.palette.grey[400]}`,
    height: '13vh',
    "@media (max-width: 420px)": {
      paddingRight: 0,
      marginRight: 0,
      borderRight: 'none',
    },
  },
  topMiddle: {
    paddingRight: 25,
    marginRight: 25,
  },
  sectionHeader: {
    paddingTop: 15,
    paddingBottom: 15,
    fontSize: 16,
    "@media (max-width: 420px)": {
      fontSize: 12,
    },
  },
  alignTable: {
    "@media (max-width: 420px)": {
      float: 'right',
    },
  },
  hr: {
    borderTop: `solid 1px ${theme.palette.grey[400]}`,
    maxWidth: 300,
  },
  money: {
    color: theme.palette.blue.blue5,
    textAlign: 'right',
    paddingLeft: 30,
  },
  failure: {
    color: theme.palette.error.dark,
  },
  success: {
    color: theme.palette.common.success,
  },
  confirmationContainer: {
    margin: '25px 0',
    width: '100%',
    border: `1px solid ${theme.palette.background.border}`,
  },
  confirmedContact: {
    lineHeight: '36px',
  },
  confirmedDate: {
    color: theme.palette.grey[500],
    lineHeight: '36px',
    marginLeft: '16px',
  },
  termsContainer: {
    width: '100%',
  },
  termsText: {
    color: theme.palette.grey[500],
  },
  termsControls: {
    textAlign: 'right',
  },
  termsInput: {
    height: '48px',
    margin: '0 25px',
  },
  hidden: {
    visibility: 'hidden',
  },
  alignLeftBooking: {
    "@media (max-width: 420px)": {
      paddingRight: '21px',
    },
  },
  paidMoney: {
    color: theme.palette.black,
    marginRight: 15,
    fontWeight: 600,
  },
  dueMoney: {
    color: theme.palette.black,
    marginRight: 15,
    fontWeight: 600,
  },
  totalDue: {
    color: theme.palette.grey[600],
    fontWeight: 600,
    marginRight: 15,
    paddingLeft: 10,
  },
  totalPaid: {
    color: theme.palette.grey[600],
    fontWeight: 600,
    marginRight: 15,
    paddingLeft: 10,
  },
  buttonFinancials: {
    color: `${theme.palette.blue.blue5} !important`,
    border: `1px solid ${theme.palette.blue.blue5} !important`,
    width: '156px !important',
    height: '40px !important',
    padding: '6px 16px !important',
    boxShadow: 'none !important',
    fontWeight: '500 !important',
    borderRadius: '2px !important',
    textTransform: 'capitalize !important',
    backgroundColor: '#fff !important',
    '&:hover': {
      backgroundColor: '#fff',
      border: `1px solid ${theme.palette.blue.blue5}`,
      boxShadow: 'none',
    },

    '&:focus': {
      backgroundColor: '#fff',
    },
  },
  leftAlign: {
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  rightAlign: {
    [theme.breakpoints.up('md')]: {
      textAlign: 'right',
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  financialsButtonsContainer: {
    backgroundColor: theme.palette.light.lightgrey,
    marginTop: 0,
    // padding: 5,
  },
  cardContent: {
    paddingBottom: '0px !important',
  },
  divider: {
    height: 2,
  },
  title: {
    textAlign: 'center',
  },
});

type Props = WithStyles<typeof styles> & {
  theme: any;
  booking: any;
  catereaseCP: string;
  getFinancialDetails: Function;
  confirmBooking: Function;
  imgSrc: string;
  makePayment: Function;
  getPaymentDetailsById: Function;
  makeCoverPaymentCall: Function;
  makePaymentCall: Function;
  getSetupIntentDetail: Function;
  postCreatePaymentLink: Function;
  getPaymentLinkDetails: Function;
  createPandaDoc: Function;
  getPandaDocStatusById: Function;
  sendPandaDoc: Function;
};

interface State {
  financials: any;
  conditionsAgreed: boolean;
  confirmedContact: string;
  termsExpended: boolean;
  openPaymentModel: boolean;
  openInvoiceModel: boolean;
  documentId: string;
  docPublicUrl: string;
  showInvoiceButton: boolean;
  paymentDetails: any;
  paymentUrl: string;
  openNewPaymentModel: boolean;
  isPaymentIframeLoading: boolean;
  paymentSuccess: boolean;
  processorType: number;
  createPaymentLinkPayload: any;
  isLoadingFinancials: boolean;
  isInvoiceIframeLoading: boolean;
  errorMessage: boolean;
  errorMessageText: string;
}

const initialState: State = {
  financials: undefined,
  conditionsAgreed: false,
  confirmedContact: '',
  termsExpended: false,
  openPaymentModel: false,
  openInvoiceModel: false,
  documentId: '',
  docPublicUrl: null,
  showInvoiceButton: true,
  paymentDetails: undefined,
  paymentUrl: null,
  openNewPaymentModel: false,
  isPaymentIframeLoading: true,
  isInvoiceIframeLoading: true,
  paymentSuccess: false,
  processorType: 0,
  createPaymentLinkPayload: null,
  isLoadingFinancials: false,
  errorMessage: false,
  errorMessageText: '',
};
const showInvoiceStatuses = [
  'document.viewed',
  'document.sent',
];

// const sendInvoiceStatuses = [
//   'document.uploaded',
//   'document.draft',
// ];

const hideInvoiceStatuses = [
  'document.completed',
  'document.approved',
];

const sentStatuses = [
  'document.sent',
  'document.viewed',
  'document.completed',
  'document.approved',
];

class Overview extends Component<Props, any> {
  public header: any = {
    'Authorization': `API-Key ${window.env.REACT_APP_PANDA_API_KEY}`,
    'Content-Type': 'application/json',
    'accept': "application/json",

  };

  submitCheckTimer: any;

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  static contextType = CompanyContext;

  context!: React.ContextType<typeof CompanyContext>;

  componentDidMount() {
    this.getFinancialDetailsById();
    window.addEventListener('message', this.handleMessage);
    const savedTab = sessionStorage.getItem('overviewActiveTab');

    if (savedTab !== null) {
      this.setState({ selectedTab: Number(savedTab) });
      sessionStorage.removeItem('overviewSelectedTab'); // cleanup
    }
  }

  getFinancialDetailsById = () => {
    this.setState({ isLoadingFinancials: true });
    const {
      booking,
      // getFinancialDetails,
      // catereaseCP,
    } = this.props;
    const conditionsAgreed = booking && !!booking.confirmedContact;

    this.setState({
      conditionsAgreed,
      paymentSuccess: false,
    });
    this.setState({ isLoadingFinancials: false });
    // getFinancialDetails(catereaseCP).then(financials => {
    //   const conditionsAgreed = booking && !!booking.confirmedContact;

    //   this.setState({
    //     financials, conditionsAgreed,
    //     paymentSuccess: false,
    //   });
    // }).finally(() => {
    //   this.setState({ isLoadingFinancials: false });
    // });
  };

  async makeInvoiceTemplateCall() {
    const { booking } = this.props;

    this.setState({ documentId: booking.documentId, isLoadingFinancials: true });
    if (!booking.documentId) {
      const payload = { eventLinkNumber: booking.eventLinkNumber };

      this.getInvoiceTemplateWithGivenData(payload);
    } else {
      this.getDocStatusById();
    }

  }

  getInvoiceTemplateWithGivenData(body: any) {
    const { createPandaDoc } = this.props;

    createPandaDoc(body)
      .then(async (response: any) => {
        if (response && response.uuid) {
          this.setState({ documentId: response.uuid });
          setTimeout(() => {
            this.getDocStatusById();
          }, 1000);
        } else {
          this.setState({ errorMessage: true, isLoadingFinancials: false, errorMessageText: 'Something went wrong while creating the invoice. The doc uuid not found. Please try again.' });
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({ errorMessage: true, isLoadingFinancials: false, errorMessageText: 'Something went wrong while creating the invoice. Please try again.' });
      });
  }

  getInvoiceURL(docId: string) {
    const { sendPandaDoc } = this.props;
    const { booking, catereaseCP } = this.props;

    const body = {
      "message": `Hello! This document was sent from the ${booking.merchantName}`,
      "silent": true,
      "documentId": docId,
      "eventLinkNumber": catereaseCP,
    };

    if (docId && !sentStatuses.includes(booking.documentStatus)) {
      this.setState({ isInvoiceIframeLoading: true });
      sendPandaDoc(body).then(async (result: any) => {
        if (result && result.recipients) {
          this.setState({ docPublicUrl: result.recipients[0].shared_link, openInvoiceModel: true, isLoadingFinancials: false });
        } else if (result && (result.error || result.status === 500)) {
          setTimeout(() => {
            this.getDocStatusById();
          }, 5000);
        }
      })
        .catch(err => {
          console.error(err);
          this.setState({ errorMessage: true, isLoadingFinancials: false, errorMessageText: 'Something went wrong while creating the invoice. Please try again.' });
        });
    } else {
      this.getDocStatusById();
    }
  }

  getDocStatusById() {
    const { booking, catereaseCP } = this.props;
    const { documentId } = this.state;

    if (documentId || booking.documentId) {
      this.props.getPandaDocStatusById(catereaseCP).then(async (result: any) => {
        if (showInvoiceStatuses.includes(result.status)) {
          if (this.state.docPublicUrl === null) {
            this.setState({ docPublicUrl: result.recipients[0].shared_link, isInvoiceIframeLoading: true });
          }
          this.setState({ showInvoiceButton: true, openInvoiceModel: true, isLoadingFinancials: false });
        } else if (hideInvoiceStatuses.includes(result.status)) {
          this.setState({ errorMessage: true, isLoadingFinancials: false, isInvoiceIframeLoading: false, errorMessageText: 'The invoice has been completed. You can find the invoice in your email.' });
          this.setState({ showInvoiceButton: false });
        } else if (result.status === 'document.draft') {
          this.getInvoiceURL(result.id);
        } else if (result.status === 'document.uploaded') {
          this.getDocStatusById();
        } else if (result && (result.error || result.status === 500)) {
          setTimeout(() => {
            this.getDocStatusById();
          }, 3000);
        }
      })
        .catch(err => {
          console.error(err);
          this.setState({ errorMessage: true, isLoadingFinancials: false, isInvoiceIframeLoading: false, errorMessageText: 'Something went wrong. Please try again.' });
        });
    }

  };

  handleMessage = async (event: MessageEvent) => {
    // if (event.origin !== 'https://dev-payment-gateway.horizoncloud.com') return;

    const tokenResponse: any =
      typeof event.data === "string" && event.data.includes("id")
        ? JSON.parse(event.data)
        : null;

    if (!tokenResponse || this.state.isPaymentIframeLoading) return;

    const { createPaymentLinkPayload } = this.state;
    const { booking } = this.props;

    const pathParts = window.location.pathname.split("/");
    const eventLinkNumber = pathParts[pathParts.length - 1];

    let payload: any;

    try {
      // ============================================================
      // ⭐ SUBSYSTEM 3 → SetupIntent / Token On File
      // ============================================================
      if (createPaymentLinkPayload.subsystem === 3) {
        const setupPayload = {
          pi_guid: tokenResponse.setupIntent.id,
          setup_intent_client_secret: tokenResponse.setupIntent.client_secret,
          setup_intent: tokenResponse.setupIntent.id,
          acct_id: createPaymentLinkPayload.accountId,
          tipAmount: tokenResponse.tipAmount,
          totalAmount: tokenResponse.totalAmount,
        };

        const data: any = await this.props.getSetupIntentDetail(setupPayload);

        payload = {
          amount: tokenResponse.totalAmount,
          tip: tokenResponse.tipAmount || 0,
          applySurcharge: createPaymentLinkPayload.applySurcharge,
          surchargeRate: createPaymentLinkPayload.surchargeRate,
          totalTax: 0,
          serialNumber: createPaymentLinkPayload.serialNumber ? createPaymentLinkPayload.serialNumber : "USA30342",

          auto_capture: true,
          paymentLinkNumber: createPaymentLinkPayload.paymentNumber,
          currency: createPaymentLinkPayload.currency ? createPaymentLinkPayload.currency : "USD",
          fee_amount: createPaymentLinkPayload.feeAmount ? createPaymentLinkPayload.feeAmount : 0,
          initiated_by: "customer",
          account_id: createPaymentLinkPayload.accountId,
          payment_method: {
            credit_card: {
              auto_update: false,
              card_holder: {
                address: {
                  country: createPaymentLinkPayload.country,
                  postal_code: data.payload.zipCode,
                },
                email: createPaymentLinkPayload.payerEmail,
                holder_name: `${booking.eventDetails.bookContact}`,
              },
              card_on_file: true,
              virtual_terminal_mode: "web",
            },
            token: {
              id: data.payload.paymentMethodId,
            },
          },
        };
      }

      // ============================================================
      // ⭐ NORMAL TOKEN FLOW
      // ============================================================
      else {
        payload = {
          amount: formatMoneyRoundOff(tokenResponse.amount) + formatMoneyRoundOff(tokenResponse.surchargeAmount * 100),
          tip: tokenResponse.tip || 0,
          applySurcharge: tokenResponse.applySurcharge,
          surchargeRate: tokenResponse.surchargeRate,
          surchargeAmount: formatMoneyRoundOff(tokenResponse.surchargeAmount * 100),
          totalTax: formatMoneyRoundOff(tokenResponse.amount),
          serialNumber: tokenResponse.serialNumber ? tokenResponse.serialNumber : "USA30342",
          auto_capture: true,

          paymentLinkNumber: createPaymentLinkPayload.paymentNumber,
          currency: tokenResponse.currency ? tokenResponse.currency : "USD",
          fee_amount: tokenResponse.feeAmount ? tokenResponse.feeAmount : 0,
          initiated_by: "customer",
          account_id: createPaymentLinkPayload.accountId,
          payment_method: {
            credit_card: {
              auto_update: false,
              card_holder: {
                address: {
                  country: "US",
                  postal_code: tokenResponse.zipCode,
                },
                email: tokenResponse.payerEmail,
                holder_name: `${booking.eventDetails.bookContact}`,
              },
              card_on_file: true,
              virtual_terminal_mode: "web",
            },
            token: {
              id: tokenResponse.id,
            },
          },
          custom_data: {
            ce_contact_id: "00001-00000000000304",
            ce_contact_num: "Q00304",
            ce_order_id: eventLinkNumber,
            ce_order_num: `${booking.eventDetails.eventNum}`,
            ce_transaction_type: "Sale",
          },
        };
      }

      // ============================================================
      // ⭐ GUARANTEED TO RUN AFTER PAYLOAD EXISTS
      // ============================================================
      console.log("Final payment payload", payload);

      await this.callPayment(payload, createPaymentLinkPayload.subsystem);

    } catch (err) {
      console.error("Payment processing failed", err);
    }
  };

  callPayment = (payload: any, processorType: any) => {
    const { makePaymentCall } = this.props;

    makePaymentCall(payload, processorType).then(response => {
      if (response && response.id) {
        this.setState({ paymentSuccess: true, isPaymentIframeLoading: false });
        window.location.reload();
      } else {
        this.setState({ isPaymentIframeLoading: false });
      }
    }).catch(err => {
      console.error(err);
      this.setState({ isPaymentIframeLoading: false });
    });
  };

  generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;

      return v.toString(16);
    });
  };

  public countValue: number = 1;

  getPaymentLinkDetails = () => {
    const { catereaseCP } = this.props;

    this.setState({ createPaymentLinkPayload: null, paymentUrl: null, isPaymentIframeLoading: true });
    this.props.getPaymentLinkDetails(catereaseCP).then(response => {
      if (response) {
        this.setState({ createPaymentLinkPayload: response }, () => { this.createPaymentLink(); });
      }
    }).catch(err => {
      console.error(err);
      this.setState({ isPaymentIframeLoading: false });
    });
  };

  createPaymentLink = () => {
    const { createPaymentLinkPayload } = this.state;
    const { booking } = this.props;

    createPaymentLinkPayload.sendEmail = createPaymentLinkPayload.sendEmail == null ? true : createPaymentLinkPayload.sendEmail;
    createPaymentLinkPayload.paymentNumber = this.generateUUID();
    createPaymentLinkPayload.payer = createPaymentLinkPayload.payer ? createPaymentLinkPayload.payer : booking.eventDetails.bookContact;
    delete createPaymentLinkPayload.iframeUrl;
    createPaymentLinkPayload.expirationDate = moment().add(5, 'd').toDate();
    createPaymentLinkPayload.transaction_details = {
      itemized_receipt: [],
      note: "Thank you for your order!",
    };
    createPaymentLinkPayload.payor_address = {
      line1: "123 South Main",
      city: "Naples",
      country: "US",
      postal_code: "34102",
      region: "F1",
    };
    createPaymentLinkPayload.paymentLinkType = 0;
    createPaymentLinkPayload.zipCode = '12345';
    this.props.postCreatePaymentLink(createPaymentLinkPayload, createPaymentLinkPayload.subsystem).then(response => {
      if (response) {
        const iFrameUrl = response.iframeUrl ? response.iframeUrl + '&viewType=event' : '';

        this.setState({ paymentUrl: iFrameUrl, openNewPaymentModel: true, isPaymentIframeLoading: false, paymentSuccess: false });

      }
    }).catch(err => {
      console.error(err);
      this.setState({ isPaymentIframeLoading: false });
    });
  };

  afterPaymentSuccess = () => {
    this.setState({ openNewPaymentModel: false, paymentSuccess: false, isPaymentIframeLoading: false });
    this.getFinancialDetailsById();
  };

  openPaymentModel = () => {
    if (!this.getPaymentDetailsById('openModel')) {
      const { makePayment } = this.props;
      const { financials } = this.state;
      const { company } = this.context;
      const paymentDetails: any = {
        totalAmount: financials.balance,
        currency: 'USD',
        serviceChargeAmount: financials.subTotal.serviceCharged,
        discountAmount: financials.subTotal.discount,
        taxAmount: financials.subTotal.taxCharged,
        tipAmount: 0,
      };
      const payload: any = {
        merchantAccountId: company.merchant_account_id,
        autoCapture: false,
        disableTips: false,
        nameOnCard: '    ',
        paymentDetails: paymentDetails,
      };

      makePayment(payload).then(paymentDetails => {
        if (paymentDetails) {
          localStorage.setItem('UUID', paymentDetails.id);
          this.setState({ paymentDetails });
          this.setState({ openPaymentModel: !this.state.openPaymentModel });
        }
      });
    } else {
      this.setState({ openPaymentModel: !this.state.openPaymentModel });
    }

  };

  handleOpenPaymentModel = () => {
    this.setState({ isPaymentIframeLoading: true, openNewPaymentModel: !this.state.openNewPaymentModel }, () => {
      this.getPaymentLinkDetails();
    });
  };

  handleClosePaymentModel = () => {
    this.setState({ openPaymentModel: false });
    this.getPaymentDetailsById("closeModel");
  };

  getPaymentDetailsById = (action: string): boolean => {
    let value = true;

    if (localStorage.getItem('UUID')) {
      const { getPaymentDetailsById, makeCoverPaymentCall, booking } = this.props;

      getPaymentDetailsById(localStorage.getItem('UUID')).then(paymentDetails => {
        if (paymentDetails) {
          localStorage.setItem('UUID', paymentDetails.id);
          this.setState({ paymentDetails });
          if (action === 'closeModel' && paymentDetails.state !== 'RequiresAction') {
            makeCoverPaymentCall(paymentDetails, booking.id).then(coverResponse => {
              localStorage.removeItem('UUID');
              window.location.reload();
            }).catch(err => {
              console.error(err);
              window.location.reload();
            }
            );
          }
          if (action === 'openModel' && paymentDetails.state !== 'RequiresAction') {
            value = false;
          } else {
            value = true;
          }
        }
      });
      if (action === 'openModel') {
        this.setState({ openPaymentModel: !this.state.openPaymentModel });
      }
    } else {
      value = false;
    }

    return value;
  };

  openInvoiceSignModel = () => {
    this.makeInvoiceTemplateCall();
  };

  formatEndDate(startDateTime, endDateTime) {
    if (startDateTime.hasSame(endDateTime, 'day')) {
      return endDateTime.toFormat('h:mm a');
    }

    return endDateTime.toFormat('cccc, LLLL d, h:mm a');
  }

  amountStyle = payment => {
    if (payment.status === 'past-due') {
      return this.props.classes.failure;
    }
    if (payment.status === 'paid') {
      return this.props.classes.success;
    }

    return this.props.classes.money;
  };

  additionalText = payment => {
    if (payment.status === 'past-due') {
      return ' - PAST DUE';
    }
    if (payment.status === 'paid') {
      return ' - PAID';
    }

    return '';
  };

  handlePanelOnClick = event => {
    const { termsExpended } = this.state;

    event.stopPropagation();
    event.preventDefault();
    this.setState({ termsExpended: !termsExpended });
  };

  handleCondictionAgree = event => {

    this.setState({ conditionsAgreed: event.target.checked });

  };

  handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ errorMessage: false, errorMessageText: '' });
  };

  render() {

    const { classes, booking, catereaseCP, theme } = this.props;
    const { financials, confirmedContact, termsExpended, openPaymentModel, openNewPaymentModel, openInvoiceModel, showInvoiceButton,
      paymentDetails, isPaymentIframeLoading, paymentSuccess, isLoadingFinancials, isInvoiceIframeLoading, conditionsAgreed } = this.state;
    // const { company } = this.context;
    const coverUser = !catereaseCP;

    const hasTermsAndCondition = booking && !!booking.termsAndConditions;
    const confirmedContactPresent = booking && !!booking.confirmedContact;
    const startDateOnly = DateTime.fromISO(booking.eventDetails.startDate).toISODate(); // "2025-09-15"
    const endDateOnly = DateTime.fromISO(booking.eventDetails.endDate).toISODate();     // "2025-09-15"
    const startDateTime = DateTime.fromISO(`${startDateOnly}T${booking.eventDetails.startTime}`);
    const endDateTime = DateTime.fromISO(`${endDateOnly}T${booking.eventDetails.endTime}`);
    const currentDate = new Date();
    const salesRep = booking && booking.eventDetails.salesRep ? booking.eventDetails.salesRep : null;

    const payments =
      booking &&
        booking.eventDetails &&
        booking.eventDetails.payments
        ? booking.eventDetails.payments
        : [];

    const paidFromPayments = payments.reduce(
      (sum, p) => sum + (p.total || 0),
      0
    );

    const total = booking && booking.eventDetails
      ? booking.eventDetails.total
      : 0;

    const balanceFromPayments = Math.max(
      total - paidFromPayments,
      0
    );

    return (
      <div>
        <LoaderOverlay isLoading={isLoadingFinancials} >

          <div className={classes.topRow}>
            <div className={classes.topHeader} style={{
              borderColor: booking.primaryColor ? `${booking.primaryColor}` : theme.palette.blue.lightblue,
              backgroundColor: booking.primaryColor ? `${booking.primaryColor}` : theme.palette.blue.lightblue,
            }}>
              <Grid container={true} className={classes.bookingDetails}>
                <Grid item={true}>
                  <div className={classes.headerTitle}>
                    {booking.eventDetails.partyName}
                  </div>
                  <div className={classes.field}>
                    {booking.eventDetails.status}
                  </div>
                </Grid>
                <Grid item={true} style={{ textAlign: 'right' }}>
                  <div className={classes.field}>
                    Event Total
                  </div>
                  <div className={classes.headerTitle}>
                    ${formatMoney(booking.eventDetails.total / 100)}
                  </div>
                </Grid>
              </Grid>
            </div>
            <div className={classes.bottomHeader}>
              <Grid container={true} className={classes.bookingDetails}>
                <Grid item={true}>
                  <div>
                    Client
                  </div>
                  <div className={classNames(classes.field, classes.subTitle)}>
                    {booking.eventDetails.client}
                  </div>
                </Grid>
                <Grid item={true}>
                  <div>
                    Event Manager
                  </div>
                  <div className={classNames(classes.field, classes.subTitle)}>
                    {booking.eventDetails.eventManager ? booking.eventDetails.eventManager : salesRep && salesRep !== '' ? salesRep : '- '}
                  </div>
                </Grid>
                <Grid item={true}>
                  <div>
                    Start Date
                  </div>
                  <div className={classNames(classes.field, classes.subTitle)}>
                    {startDateTime.toFormat('M/dd/yyyy')}
                  </div>
                </Grid>
                <Grid item={true}>
                  <div>
                    End Date
                  </div>
                  <div className={classNames(classes.field, classes.subTitle)}>
                    {endDateTime.toFormat('M/dd/yyyy')}
                  </div>
                </Grid>
                <Grid item={true}>
                  <div>
                    Start Time
                  </div>
                  <div className={classNames(classes.field, classes.subTitle)}>
                    {startDateTime.toFormat('h:mma')}
                  </div>
                </Grid>
                <Grid item={true}>
                  <div>
                    End Time
                  </div>
                  <div className={classNames(classes.field, classes.subTitle)}>
                    {endDateTime.toFormat('h:mma')}
                  </div>
                </Grid>
              </Grid>
            </div>

            {/* <div className={classes.topLeft}>
            <div className={classes.label}>
              {booking.name}
            </div>
            <div className={booking.status ? classes.bookingInfo : `${classes.bookingInfo} ${classes.hidden}`}>
              Status | {booking.status}
            </div>
          </div> */}
            {/* <div className={classes.alignLeftBooking}>
            <div>
              {booking && booking.contact && booking.contact.name &&
                <div >
                  <PersonOutline className={classes.icon} /> {booking.contact.name}
                </div>
              }
              <div >
                <EventNote className={classes.icon} /> {startDateTime.toFormat('MMMM dd yyyy')}
              </div>
              <div >
                <AccessTime className={classes.icon} /> {startDateTime.toFormat('hh:mma').toLowerCase()} - {endDateTime.toFormat('hh:mma').toLowerCase()}
              </div>
              <div>
                <Place className={classes.icon} /> {booking.name}
              </div>
            </div>
            <div style={{ fontSize: 25 }}>
              {startDateTime.toFormat('EEEE , MMMM dd, hh:mma')}- {endDateTime.toFormat('EEEE , MMMM dd, hh:mma')}
            </div>
            <div className={classes.bookingInfo}>
              Event Manager :  {booking.eventManager ? booking.eventManager : salesRep && salesRep !== '' ? salesRep : '- '}
            </div>
            <div className={booking.eventManager ? classes.bookingInfo : `${classes.bookingInfo} ${classes.hidden}`}>
              Event Manager | {booking.eventManager}
            </div>
          </div> */}
            {/* <div className={classes.imgContent}>
            <CompanyName fontSize={28} />
            {!!imgSrc &&
              <img src={imgSrc} alt="logo" className={classes.imageLogo} />
            }
          </div> */}

          </div>
          {booking &&
            <div className={classes.financialsContainer}>
              <Grid container={true} spacing={4} className={classes.container}>
                <Grid item={true} xs={12} sm={12} md={6} className={classes.payments}>
                  <div className={classes.sectionHeader}>Payments</div>
                  <div className={classes.paymentsListContainer}>
                    {booking.eventDetails && booking.eventDetails.payments.length > 0 ?
                      booking.eventDetails.payments.map((payment, index) =>
                        <Grid key={index} container={true} className={classes.paymentsContainer}>
                          <div className={classes.paymentsCardTitle}>Payment</div>
                          <Grid item={true}>
                            <div>
                              <div>Date</div>
                              <div className={classNames(classes.field, classes.subTitle)}>{DateTime.fromISO(payment.payDate).toFormat('MM/dd/yyyy')}</div>
                            </div>
                          </Grid>
                          <div className={classes.paymentsField}>
                            <Grid item={true}>
                              <div>
                                <div className={classes.title}>Amount</div>
                                <div className={classNames(classes.field, classes.subTitle)}>${formatMoney(payment.total / 100)}</div>
                              </div>
                            </Grid>
                            <Grid item={true}>
                              <div>
                                <div className={classes.title}>Balance</div>
                                <div className={classNames(classes.field, classes.subTitle)}>${formatMoney(balanceFromPayments / 100)}</div>
                              </div>
                            </Grid>
                          </div>
                        </Grid>) : <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>No payments have been made yet.</div>
                    }
                  </div>
                  {
                    booking.eventDetails && booking.eventDetails.payments.length > 0 &&
                    <React.Fragment>
                      <Grid container={true} spacing={1}>
                        <Grid item xs={6} sm={6} md={6}></Grid>
                        <Grid item={true} xs={6} sm={6} md={6} className={classes.paymentFooter}
                          style={{
                            backgroundColor: booking.primaryColor ? `${booking.primaryColor}` : theme.palette.blue.lightblue,
                          }}
                        >
                          <Grid container={true}
                            style={{ padding: "0 15px" }}>
                            <Grid item={true} xs={6} sm={6} md={6} lg={6}>
                              <span className={classes.totalPaid}>PAID</span> <b className={classes.paidMoney}>${formatMoney(paidFromPayments / 100)}</b>
                            </Grid>
                            <Grid item={true} xs={6} sm={6} md={6} lg={6} style={{
                              display: 'flex',
                              alignItems: 'flex-end',
                              justifyContent: 'flex-end',
                            }}>
                              <span className={classes.totalDue}>DUE</span> <b className={classes.dueMoney}>${formatMoney(balanceFromPayments / 100)}</b>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                    </React.Fragment>

                  }

                  {/* <div className={classes.hr}></div>
              {payments.map(payment => (<div key={payment.date}>{payment.date}: <span className={this.amountStyle(payment)}>${payment.amount + this.additionalText(payment)}</span></div>))} */}
                </Grid>
                <Grid item={true} xs={12} sm={12} md={6} className={classes.financials}>
                  <div className={classes.sectionHeader}>Financial</div>
                  <div className={classes.financialSummary} style={{
                    backgroundColor: booking.secondaryColor ? `${booking.secondaryColor}` : theme.palette.light.lightgrey,
                  }}>
                    <Card elevation={0} className={classes.cardContainer}
                      style={{
                        borderBottomColor: booking.primaryColor ? `${booking.primaryColor}` : theme.palette.blue.lightblue,
                      }}
                    >
                      <div className={classes.financials2}>
                        <div className={classes.financialsHeader} style={{
                          backgroundColor: booking.primaryColor ? `${booking.primaryColor}` : theme.palette.blue.lightblue,
                        }}>Financials</div>
                        <CardContent className={classes.cardContent}>
                          <div className={classes.finacialsField}>
                            <div>Order Subtotal</div>
                            <div>${formatMoney(booking.eventDetails.subTotal / 100)}</div>
                          </div>
                          <div className={classes.finacialsField}>
                            <div>Service Charge</div>
                            <div>${formatMoney(booking.eventDetails.servChg / 100)}</div>
                          </div>
                          <div className={classes.finacialsField}>
                            <div>Gratuity</div>
                            <div>${formatMoney(booking.eventDetails.gratuity / 100)}</div>
                          </div>
                          <div className={classes.finacialsField}>
                            <div>Tax</div>
                            <div>${formatMoney(booking.eventDetails.tax / 100)}</div>
                          </div>
                          <div className={classes.finacialsField}>
                            <div>Tip</div>
                            <div>${formatMoney(booking.eventDetails.tip / 100)}</div>
                          </div>
                          <Divider className={classes.divider} />
                          <div className={classes.finacialsField2}>
                            <div>Total</div>
                            <div>${formatMoney(booking.eventDetails.total / 100)}</div>
                          </div>
                          {coverUser &&
                            <div className={classes.finacialsField2}>
                              <div>Minimum Spend: <span className={financials.remaining <= 0 ? classes.success : classes.failure}>${formatMoney(
                                booking.eventDetails.minSpend / 100)} - {booking.eventDetails.balance <= 0 ? 'Met' : 'Not Met'}</span></div>
                            </div>
                          }
                          <div className={classes.finacialsField2}>
                            <div>Total Paid</div>
                            <div>${formatMoney(booking.eventDetails.paid / 100)}</div>
                          </div>
                          <div className={classes.finacialsField2}>
                            <div>Balance</div>
                            <div>${formatMoney(booking.eventDetails.balance / 100)}</div>
                          </div>
                        </CardContent>
                      </div>
                    </Card>
                    <Grid item={true} xs={12} sm={12} md={12} className={classes.financialsButtonsContainer}>
                      <Grid container
                        spacing={0.1}>
                        {showInvoiceButton && booking.requestPandaSignature &&
                          <Grid item xs={12} sm={6}>
                            <PrimaryButton
                              variant="outlined"
                              className={classes.buttonFinancials}
                              onClick={() => this.openInvoiceSignModel()}
                            >
                              Document E-Sign
                            </PrimaryButton>
                          </Grid>
                        }
                        {booking.requestPayment &&
                          <Grid item xs={12} sm={6}>
                            <PrimaryButton
                              variant="outlined"
                              className={classes.buttonFinancials}
                              onClick={() => this.handleOpenPaymentModel()}
                            >
                              Make Payment
                            </PrimaryButton>
                          </Grid>}
                      </Grid>
                    </Grid>
                  </div>
                  {/* <table className={classes.alignTable}>
                  <tr>
                    <td>Subtotal</td>
                    <td></td>
                    <td className={classes.money}>${formatMoney(financials.subTotal.subTotal)}</td>
                  </tr>
                  <tr>
                    <td>Tax</td>
                    <td></td>
                    <td className={classes.money}>${formatMoney(financials.subTotal.taxCharged)}</td>
                  </tr>
                  <tr>
                    <td style={{ borderBottom: "1px dotted #ddd" }}>Service Charge</td>
                    <td style={{ borderBottom: "1px dotted #ddd" }}></td>
                    <td className={classes.money} style={{ borderBottom: "1px dotted #ddd" }}>${formatMoney(financials.subTotal.serviceCharged)}</td>
                  </tr>
                  <tr>
                    <td>Estimated Total Charges</td>
                    <td></td>
                    <td className={classes.money}>${formatMoney(financials.totalWithDiscount)}</td>
                  </tr>

                </table>
                {coverUser &&
                  <div>Minimum Spend: <span className={financials.remaining <= 0 ? classes.success : classes.failure}>${formatMoney(financials.minimum)} - {financials.remaining <= 0 ? 'Met' : 'Not Met'}</span></div>
                } */}
                </Grid>
              </Grid>
              {hasTermsAndCondition &&
                <div className={classes.confirmationContainer}>
                  <Accordion expanded={termsExpended} elevation={0}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon onClick={event => this.handlePanelOnClick(event)} />}
                      aria-label="Expand"
                      aria-controls="additional-actions1-content"
                      id="additional-actions1-header"

                    >

                      <FormControlLabel
                        aria-label="Acknowledge"
                        onClick={event => this.handleCondictionAgree(event)}
                        onFocus={event => event.stopPropagation()}
                        control={
                          <Checkbox
                            checked={conditionsAgreed}
                          />
                        }
                        label="I agree to the contract terms and conditions"
                      />
                      {confirmedContactPresent &&
                        <span className={classes.confirmedContact}>{booking.confirmedContact}</span>
                      }
                      {booking.confirmedContactDate &&
                        <span className={classes.confirmedDate}>{DateTime.fromISO(booking.confirmedContactDate).toFormat('LLLL d, yyyy')}</span>
                      }
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className={classes.termsContainer}>
                        <span className={classes.termsText}>
                          <CompanyTerms booking={booking} />
                        </span>
                        {!confirmedContactPresent &&
                          <div className={classes.termsControls}>
                            <span className={classes.termsText}>
                              {currentDate.toDateString()}
                            </span>
                            <FilledInput
                              id="full-name"
                              className={classes.termsInput}
                              value={confirmedContact}
                              placeholder="Full Name"
                              onChange={event => this.setState({ confirmedContact: event.target.value })}
                              inputRef={input => input && input.focus()}
                            />
                            <Button
                              variant="outlined"
                              classes={{ root: classes.button, disabled: classes.buttonDisabled }}
                              onClick={() => {
                                this.props.confirmBooking(booking, confirmedContact);
                                this.setState({ termsExpended: false });
                              }}
                              disabled={!confirmedContact}
                            >
                              Agree
                            </Button>
                          </div>
                        }
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              }
            </div>}

          <Dialog onClose={() => this.handleClosePaymentModel()} aria-labelledby="customized-title" open={openPaymentModel}
            fullWidth={true}
            maxWidth="md"
          >
            <DialogTitle id="customized-title" onClose={() => this.handleClosePaymentModel()}>
              Make Payment
            </DialogTitle>
            <DialogContent style={{ display: 'flex', justifyContent: 'center' }}>
              {paymentDetails &&
                <iframe title="HPayCustomIframe" id='HPayCustomIframe'
                  style={{ border: 'none', minWidth: 700, maxWidth: 'auto', minHeight: 590, maxHeight: '80vh' }}
                  src={`${paymentDetails.actionUrl}`} />
              }

            </DialogContent>
          </Dialog>

          <Dialog onClose={() => this.setState({ openInvoiceModel: false })}
            aria-labelledby="customized-dialog-title"
            fullWidth
            maxWidth="xl"
            open={openInvoiceModel}>
            <DialogTitle id="customized-dialog" onClose={() => {
              this.setState({ openInvoiceModel: false, isLoadingFinancials: false, isInvoiceIframeLoading: false });
            }}>
              e-Sign Invoice
            </DialogTitle>
            <DialogContent style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <LoaderOverlay isLoading={isInvoiceIframeLoading}>
                <iframe title="Invoice"
                  style={{
                    border: "none",
                    width: "75vw",
                    height: "75vh",
                  }}
                  src={this.state.docPublicUrl}
                  onLoad={() => this.setState({ isInvoiceIframeLoading: false })} />
              </LoaderOverlay>
            </DialogContent>
          </Dialog>

          <Dialog onClose={() => this.setState({ openNewPaymentModel: false, paymentSuccess: false, isPaymentIframeLoading: false })}
            aria-labelledby="customized-dialog-title"
            open={openNewPaymentModel}>
            <DialogTitle id="customized-dialog" onClose={() => {
              this.setState({ openNewPaymentModel: false, paymentSuccess: false, isPaymentIframeLoading: false });
            }}>
              Make Payment
            </DialogTitle>
            <DialogContent >

              <LoaderOverlay isLoading={isPaymentIframeLoading}>
                {paymentSuccess ? (
                  <Paper elevation={0} style={{ padding: '40px', textAlign: 'center' }}>
                    <Box display="flex" justifyContent="center" mb={3}>
                      <CheckCircleIcon style={{ fontSize: 60, color: 'green' }} />
                    </Box>

                    <Typography variant="h4" gutterBottom>
                      Payment Successful
                    </Typography>

                    <Typography variant="body1" gutterBottom>
                      Thank you! Your payment has been processed successfully.
                    </Typography>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => this.afterPaymentSuccess()}
                      style={{ marginTop: '30px' }}
                    >
                      Continue
                    </Button>
                  </Paper>
                ) : (
                  <iframe
                    title="paymentWindow"
                    src={this.state.paymentUrl}
                    style={{
                      width: '580px',
                      height: '740px',
                      border: 'none',
                      overflow: 'hidden',
                    }}
                    scrolling="no"
                  />
                )}
              </LoaderOverlay>
            </DialogContent>
          </Dialog>
        </LoaderOverlay>
        <Snackbar open={this.state.errorMessage} autoHideDuration={6000} onClose={() => this.setState({ errorMessage: false })}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {this.state.errorMessageText}
          </Alert>
        </Snackbar>
      </div >
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  catereaseCP: state.caterease.catereaseCP,
});

const mapDispatchToProps = {
  getFinancialDetails,
  confirmBooking,
  makePayment,
  getPaymentDetailsById,
  makeCoverPaymentCall,
  makePaymentCall,
  postCreatePaymentLink,
  getSetupIntentDetail,
  getPaymentLinkDetails,
  createPandaDoc,
  getPandaDocStatusById,
  sendPandaDoc,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(Overview));

